import Vue from 'vue'
import moment from 'moment'

// import 'moment/locale/sr'
import 'moment/locale/en-in'

Vue.use(require('vue-moment'), {
  moment
})
